import { useEffect, useState, useMemo, useCallback } from "react";
import Select from "react-select";
import { fetchFtmsList } from "../service";
import { theme } from "../../theme";

const FtmList = ({ selectedFtm, setSelectedFtm }) => {
    const [loading, setLoading] = useState(false);
    const [optionsList, setOptionsList] = useState([]);

    const customStyles = useMemo(() => ({
        control: (base) => ({
            ...base,
            borderRadius: "10px",
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "10px",
            overflow: "hidden",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? theme.main_code
                : state.isFocused
                ? "#f1f5ff"
                : "#fff",
            color: state.isSelected ? "#fff" : "#333",
        }),
    }), []);

    useEffect(() => {
        const getFtmsList = async () => {
            setLoading(true);

            try {
                const response = await fetchFtmsList();

                const options =
                    response?.data?.map((ftm) => ({
                        value: ftm.ftm_id,
                        label: `${ftm.ftm_forename} ${ftm.ftm_surname}`,
                    })) || [];

                setOptionsList(options);
            } catch (error) {
                console.error("Error fetching FTMs list:", error);
            } finally {
                setLoading(false);
            }
        };

        getFtmsList();
    }, []);

    const handleChange = useCallback(
        (option) => {
            setSelectedFtm(option);
        },
        [setSelectedFtm]
    );

    return (
        <div style={{ width: 250 }}>
            <Select
                options={optionsList}
                value={selectedFtm}
                onChange={handleChange}
                placeholder="Search tradespersons..."
                isSearchable
                isLoading={loading}
                styles={customStyles}
            />
        </div>
    );
};

export default FtmList;